import {useCallback, useState} from "react";
import {useSiren} from "../SirenContext";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "./useNavigateWithClientID";
import {ContactGroup} from "../typedefs";

export function useEditContactGroup(contactGroup: ContactGroup) {
    const [name, setName] = useState(contactGroup.name);
    const [contactIDs, setContactIDs] = useState<string[]>(contactGroup.contactIDs ?? []);
    const [isLoading, setIsLoading] = useState(false);

    const {navigateWithClientID} = useNavigateWithClientID();
    const {setToast} = useSiren();

    const submit = useCallback(async () => {
        setIsLoading(true);
        try {
            await platformAPI.patch(`api/contact-groups/${contactGroup.id}`, {name, contactIDs});
            setToast("Contact group updated", "success");
            navigateWithClientID("/siren/groups");
        } finally {
            setIsLoading(false);
        }
    }, [name, contactIDs, contactGroup.id]);

    return {name, setName, contactIDs, setContactIDs, isLoading, submit};
}
